module.exports = __webpack_public_path__ + "img/chrome.e88da90d.svg";